<template>
    <div class="search-result">
        <div class="search-result__inner">
            <div class="search-result__meta">
                <span v-if="type" class="search-result__type">{{ type }}</span>
                <span v-if="formattedDate" class="search-result__date">
                   {{ formattedDate }}
                </span>
            </div>
            <a :href="`/node/${result.nid}`" class="search-result__title-link">
                <h3 v-html="highlight(result.title)" class="search-result__title"></h3>
            </a>
            <div v-if="matchedResult.matchedWords.length" class="search-result__excerpt" v-html="matchedResult.value"></div>
            <div v-else-if="result.field_concert_intro" v-html="highlight(trim(result.field_concert_intro, 130, true))" class="search-result__excerpt"></div>
            <div v-else-if="result.field_intro" v-html="highlight(trim(result.field_intro, 130, true))" class="search-result__excerpt"></div>
            <div v-else-if="result.body" v-html="highlight(trim(result.body, 130, true))" class="search-result__excerpt"></div>
            <div v-else-if="result.artist_title" v-html="highlight(trim(result.artist_title, 130, true))" class="search-result__excerpt"></div>
        </div>
    </div>
</template>

<script src="./SearchResult.js"></script>

